import script from "./review-pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./review-pagination.vue?vue&type=script&setup=true&lang=js"

import "./review-pagination.vue?vue&type=style&index=0&id=59ea0e54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ea0e54"]])

export default __exports__